import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '../../../../library/button/button';
import Message from '../../../message/message';

import {
  useNavigateTo,
  useProductSearchNavigation
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics.js';
import { ProductTypeProp } from '../../../../shared/utils/prop-types/prop-types';

import { PRODUCT_TYPES } from '../../../../shared/constants/products';
import { SEARCH_TYPES } from '../../../../shared/constants/search-types';

import './fit-message.scss';

function FitMessage(props) {
  const {
    doesFit = false,
    fitment,
    isLoading,
    isPackage,
    isSingular,
    isTextSearch,
    productType = PRODUCT_TYPES.TIRES
  } = props;

  const location = useLocation();
  const navigateTo = useNavigateTo();
  const { onSearchTypeSelected, onShopAllAccessories, onShopAllTires } =
    useProductSearchNavigation({
      fitment
    });

  let productMessage = 'tires';
  let fitmentActionMessage = '';
  let isWarning = false;
  let isInfo = false;
  let isError = false;
  let isSuccess = false;
  let message = '';
  let fitmentAction = null;

  function handleEnterYourVehicleClick() {
    const locationHash = '#/fitment/vehicle/continue-to/close';
    const url = new URL(window.location);
    trackAction('product_fitment_validation_banner');
    if (Number(url.searchParams.get('page')) !== 0) {
      url.hash = locationHash;
      url.searchParams.set('page', 0);
      window.location.assign(url);
    } else {
      window.location.hash = locationHash;
    }
  }

  function handleShopProductsThatFitClick() {
    trackAction('product_fitment_validation');
    if (productType === PRODUCT_TYPES.TIRES) {
      onShopAllTires();
    } else if (productType === PRODUCT_TYPES.ACCESSORIES) {
      onShopAllAccessories();
    } else {
      onSearchTypeSelected(SEARCH_TYPES.WHEELS);
    }
  }

  if (PRODUCT_TYPES[productType] === PRODUCT_TYPES.ACCESSORIES) {
    productMessage = 'products';
  } else if (PRODUCT_TYPES[productType] === PRODUCT_TYPES.WHEELS) {
    productMessage = 'wheels';
  }

  if (!fitment) {
    fitmentActionMessage = 'Enter your vehicle';
    fitmentAction = handleEnterYourVehicleClick;
    isWarning = true;
    message = `to ensure these ${productMessage} fit`;
  }

  if (!isLoading && fitment) {
    if (doesFit || isPackage) {
      fitmentAction = null;
      fitmentActionMessage = null;
      isSuccess = true;
      message = isPackage
        ? 'This package fits your vehicle'
        : `${
            isSingular ? 'This fits' : `These ${productMessage} fit`
          } your vehicle`;
      if (isTextSearch) {
        fitmentAction = () => {
          navigateTo(`${location.pathname}${location.search}&isSearchAll=true`);
        };
        fitmentActionMessage = 'view all results for this search';
      } else {
        fitmentAction = null;
        fitmentActionMessage = null;
      }
    } else if (productType === PRODUCT_TYPES.TIRES && !doesFit) {
      isWarning = true;
      message = 'These tires may not fit your vehicle.';
    } else {
      fitmentAction = handleShopProductsThatFitClick;
      fitmentActionMessage = `shop ${productMessage} that fit`;
      isError = true;
      message = `${
        isSingular
          ? `This ${productMessage} does not`
          : `These ${productMessage} don't`
      } fit your vehicle`;
    }
  }

  return (
    <div className="fit-message" styleName="container">
      <Message
        isAlignCenter
        isError={isError}
        isInfo={isInfo}
        isSuccess={isSuccess}
        isWarning={isWarning}
        message={
          <>
            {' '}
            {message && (
              <>
                {!fitment && fitmentAction && (
                  <Button onClick={fitmentAction} weight="heavy">
                    {fitmentActionMessage}
                  </Button>
                )}{' '}
                {message}
                {fitment && fitmentAction && (
                  <Button onClick={fitmentAction} styleName="button">
                    {fitmentActionMessage}
                  </Button>
                )}
              </>
            )}
          </>
        }
      />
    </div>
  );
}

FitMessage.propTypes = {
  doesFit: PropTypes.bool.isRequired,
  fitment: PropTypes.any,
  isLoading: PropTypes.bool,
  isPackage: PropTypes.bool,
  isSingular: PropTypes.bool,
  isTextSearch: PropTypes.bool,
  productType: ProductTypeProp
};

export default FitMessage;
